import {
  Box,
  Chip,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";
import { LLMSTSBResponse } from "../../../../types/llm";

interface ResultsProps {
  results: LLMSTSBResponse | undefined;
}

const Results = (props: ResultsProps): ReactElement => {
  const { results } = props;

  if (!results) {
    return <></>;
  }

  const normalizedSimilarity = results.similarity > 1 ? results.similarity / 5 : results.similarity;
  const similarityPercent = Math.round(normalizedSimilarity * 100);
  const similarityText = results.similarity > 1 ? results.similarity.toFixed(2) + "/5" : similarityPercent + "%";

  return (
    <Paper
      elevation={2}
      sx={{
        padding: 3,
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack spacing={2}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Result
        </Typography>

        <Box>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Model
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {results.model}
          </Typography>
        </Box>

        <Box>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Similarity
          </Typography>
          <Box sx={{ marginTop: 0.5 }}>
            <Chip
              label={similarityText}
              color={similarityPercent >= 70 ? "success" : "default"}
              variant={similarityPercent >= 70 ? "filled" : "outlined"}
              sx={{ fontWeight: 700 }}
            />
          </Box>
        </Box>

        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ marginBottom: 1 }}
          >
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              Similarity
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              {similarityPercent}%
            </Typography>
          </Stack>
          <LinearProgress
            variant="determinate"
            value={similarityPercent}
            sx={{ height: 8, borderRadius: 1 }}
          />
        </Box>
      </Stack>
    </Paper>
  );
};

export default Results;
